import { Box } from '@mantine/core';
import { keyframes } from '../utils/keyframes';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface RubberBandProps {
  children: React.ReactNode;
  active?: boolean;
  duration?: number;
  infinite?: boolean;
  count?: number;
}

const rubberBandKeyframes = keyframes({
  '0%': { transform: 'scale3d(1, 1, 1)' },
  '30%': { transform: 'scale3d(1.25, 0.75, 1)' },
  '40%': { transform: 'scale3d(0.75, 1.25, 1)' },
  '50%': { transform: 'scale3d(1.15, 0.85, 1)' },
  '65%': { transform: 'scale3d(0.95, 1.05, 1)' },
  '75%': { transform: 'scale3d(1.05, 0.95, 1)' },
  '100%': { transform: 'scale3d(1, 1, 1)' },
});

const RubberBand = forwardRef<HTMLDivElement, RubberBandProps>(
  (
    {
      children,
      active = true,
      duration = 1000,
      infinite = false,
      count = 1,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();

    if (reducedMotion || !active) {
      return <Box ref={ref}>{children}</Box>;
    }

    const iterationCount = infinite ? 'infinite' : count;

    return (
      <Box
        ref={ref}
        style={{
          animation: `${rubberBandKeyframes} ${duration}ms ease-in-out ${iterationCount}`,
          display: 'inline-block',
        }}
      >
        {children}
      </Box>
    );
  }
);

RubberBand.displayName = 'RubberBand';

export default RubberBand;
